function resetImages()
{   
  for (var i = 0; i <= window.stimFieldsMax; i++){stimContainers[i].src = "";}

  // document.getElementById("imageTarget").src = ""; document.getElementById("image1").src = ""; document.getElementById("image2").src = "";
  // document.getElementById("image3").src = ""; document.getElementById("image4").src = ""; document.getElementById("image5").src = "";
  // document.getElementById("image6").src = "";
}